import { render, staticRenderFns } from "./IngredientGroups.vue?vue&type=template&id=67c9ba54&scoped=true"
import script from "./IngredientGroups.vue?vue&type=script&lang=js"
export * from "./IngredientGroups.vue?vue&type=script&lang=js"
import style0 from "./IngredientGroups.vue?vue&type=style&index=0&id=67c9ba54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c9ba54",
  null
  
)

export default component.exports